import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

export enum RouteName {
  Home = 'Home',
  ExerciseList = 'Exercise List',
  ExerciseAdd = 'Add an exercise',
  ExerciseEdit = 'Edit exercise',
  ExerciseActivity = 'Exercise Activity',
  ExerciseActivityAdd = 'Add Exercise Activity',
}

const routes: RouteConfig[] = [
  {
    path: '/',
    name: RouteName.Home,
    component: Home,
  },
  {
    path: '/exercises',
    name: RouteName.ExerciseList,
    component: () => import(/* webpackChunkName: "exercise-list" */ '../views/ExerciseList.vue'),
  },
  {
    path: '/exercises/add',
    name: RouteName.ExerciseAdd,
    component: () => import(/* webpackChunkName: "exercise-add" */ '../views/ExerciseAdd.vue'),
  },
  {
    name: RouteName.ExerciseEdit,
    path: '/exercises/edit/:id',
    component: () => import(/* webpackChunkName: "exercise-edit" */ '../views/ExerciseEdit.vue'),
    props: true,
  },
  {
    path: '/exercises/activity/add',
    name: RouteName.ExerciseActivityAdd,
    component: () => import(/* webpackChunkName: "exercise-activity-add" */ '../views/ExerciseActivityAdd.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
